import { render, staticRenderFns } from "./DocumentPrintSalesService.vue?vue&type=template&id=4fbf5e3b&scoped=true"
import script from "./DocumentPrintSalesService.vue?vue&type=script&lang=js"
export * from "./DocumentPrintSalesService.vue?vue&type=script&lang=js"
import style0 from "./DocumentPrintSalesService.vue?vue&type=style&index=0&id=4fbf5e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbf5e3b",
  null
  
)

export default component.exports